(function ($) {
  'use strict';

  var $navTrigger = $('#nav-trigger');
  var $body = $('body');

  $navTrigger.on('click', function(){
    $body.toggleClass('nav-active');
  });
}(jQuery));